import { defineComponent as o, openBlock as t, createBlock as c, unref as l, mergeProps as r, withCtx as h, createElementVNode as m } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const s = /* @__PURE__ */ o({
  name: "IconThumbsDownOutlined",
  __name: "IconThumbsDownOutlined",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const n = a;
    return (u, e) => (t(), c(l(p), r(n, { "view-box": "0 0 24 24" }), {
      default: h(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M19.73 12.066a2 2 0 0 1 .533.36 1.923 1.923 0 0 1 0 2.814c-.41.384-.977.593-1.638.593H12.54l.476 2.383a3.046 3.046 0 0 1-1.624 3.323 1.21 1.21 0 0 1-1.648-.594l-3.172-7.191a5 5 0 0 1-.219-.588H4.375a1.25 1.25 0 0 1-1.25-1.25v-6a1.25 1.25 0 0 1 1.25-1.25h2.5A.8.8 0 0 1 7.128 4.71a2.24 2.24 0 0 1 1.247-.377h7.75c.66 0 1.229.21 1.638.594a1.92 1.92 0 0 1 .464 2.146c.706.343 1.124 1.013 1.13 1.754a1.9 1.9 0 0 1-.25.968 1.924 1.924 0 0 1 .623 2.271m-13.566-5.9H4.625v5.5h1.5V6.584a2.3 2.3 0 0 1 .039-.417M17.715 8.52c-.09-.086-.267-.186-.59-.186h-1.5a.75.75 0 1 1 0-1.5h.5c.34 0 .522-.103.612-.187a.424.424 0 0 0 0-.625c-.09-.085-.273-.188-.612-.188h-7.75a.75.75 0 0 0-.75.75v5.052a3.75 3.75 0 0 0 .32 1.514l3.036 6.884a1.55 1.55 0 0 0 .565-1.523l-.656-3.28a.75.75 0 0 1 .735-.897h7c.34 0 .521-.103.612-.187a.424.424 0 0 0 0-.625c-.09-.085-.273-.188-.612-.188h-2.5a.75.75 0 0 1 0-1.5h1.5c.34 0 .521-.103.612-.187a.424.424 0 0 0 0-.625c-.09-.085-.273-.188-.612-.188l-.45.001h-1.05a.75.75 0 0 1 0-1.5h1.006c.336-.002.51-.104.596-.185a.42.42 0 0 0 .13-.309.45.45 0 0 0-.142-.321",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
